export var mutations = {
    setLocations: function (s, payload) {
        s.locations = payload;
    },
    setLoading: function (s, payload) {
        s.loading = payload;
    },
};
